import { render, staticRenderFns } from "./PullUpMenu.vue?vue&type=template&id=6f072b6a&"
import script from "./PullUpMenu.vue?vue&type=script&lang=js&"
export * from "./PullUpMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports